import { onValue } from "firebase/database";
import { LaunchError } from "./errors";
import { store } from "../app/store";
import { isRtdbPermissionDenied } from "./rtdbErrors.js";

// RTDB listeners fail outside try/catch. Permission errors on logout are
// expected and are not reported. Every other listener failure is.
export const listenDatabaseValue = (
  query,
  callback,
  cancelCallback,
  options
) => {
  const onCancel = (error) => {
    if (!isRtdbPermissionDenied(error)) {
      store.dispatch(
        LaunchError(error, false, [], {
          functionName: "listenDatabaseValue",
          capture: "exception",
          tags: { source: "rtdb" },
          context: {
            path:
              typeof query?.toString === "function" ? query.toString() : null,
          },
        })
      );
    }
    if (typeof cancelCallback === "function") {
      cancelCallback(error);
    }
  };

  if (typeof cancelCallback === "function") {
    return onValue(query, callback, onCancel, options);
  }
  if (cancelCallback && typeof cancelCallback === "object") {
    return onValue(query, callback, onCancel, cancelCallback);
  }
  return onValue(query, callback, onCancel);
};
